import { render } from "./CCTV.vue?vue&type=template&id=49d7b5b6&scoped=true"
import script from "./CCTV.vue?vue&type=script&lang=js"
export * from "./CCTV.vue?vue&type=script&lang=js"

import "./CCTV.vue?vue&type=style&index=0&id=49d7b5b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d7b5b6"]])

export default __exports__